/* ======================
   SPARE PARTS BROWSER
   ====================== */

(function () {
  "use strict";

  /* ======================
       STATE
       ====================== */

  let selectedBrand = "";
  let selectedBrandId = "";

  let selectedModel = "";
  let selectedModelId = "";
  let selectedModelName = "";

  let selectedCategory = "";
  let selectedCollection = "";
  let productRequestController = null;
  let productRequestToken = 0;
  let countRequestToken = 0;
  const countCache = new Map();

  /* ======================
       ELEMENT HELPERS
       ====================== */

  function getElement(selector) {
    return document.querySelector(selector);
  }

  function getElements(selector) {
    return document.querySelectorAll(selector);
  }

  /* ======================
       SAFE SELECTOR
       ====================== */

  function escapeSelector(value) {
    if (window.CSS && typeof window.CSS.escape === "function") {
      return window.CSS.escape(value);
    }

    return String(value || "").replace(
      /([ !"#$%&'()*+,./:;<=>?@[\\\]^`{|}~])/g,
      "\\$1",
    );
  }

  /* ======================
       NORMALIZE MODEL NAME
       ====================== */

  function normalizeModelName(value) {
    return String(value || "")
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, " ")
      .replace(/\s+/g, " ")
      .trim();
  }

  /* ======================
       GET MODEL GID
       ====================== */


function getModelGid() {
  const id = String(selectedModelId || "").trim();

  if (!id) return "";

  if (id.startsWith("gid://shopify/Metaobject/")) {
    return id;
  }

  // A numeric Metaobject ID can be converted to a GID.
  if (/^\d+$/.test(id)) {
    return "gid://shopify/Metaobject/" + id;
  }

  // Do not construct an invalid GID from an unexpected value.
  console.error("Invalid mobile model Metaobject ID:", id);
  return "";
}

function getModelFilterUrl() {
  const collection = String(selectedCollection || "").trim();
  const modelGid = getModelGid();

  if (!collection || !modelGid) {
    console.error("Missing collection handle or valid model ID.", {
      selectedCollection,
      selectedModelId,
      selectedModelName
    });

    return null;
  }

  const url = new URL(
    "/collections/" + encodeURIComponent(collection),
    window.location.origin
  );

  url.searchParams.set(
    "filter.p.m.custom.compatible_models",
    modelGid
  );

  return url.toString();
}
  /* ======================
       SHOW MODELS
       ====================== */

  function showModels() {
    const modelsGrid = getElement(".models-grid");

    const partsGrid = getElement(".parts-grid");

    const productsGrid = getElement(".products-grid");

    const title = getElement(".main-browser-title");

    const allModelsBtn = getElement(".all-models-btn");

    const backModelsBtn = getElement(".back-models-btn");

    const backPartsBtn = getElement(".back-parts-btn");

    if (modelsGrid) {
      modelsGrid.classList.remove("d-none");
    }

    if (partsGrid) {
      partsGrid.classList.add("d-none");
    }

    if (productsGrid) {
      productsGrid.classList.add("d-none");
    }

    if (title) {
      title.textContent = "Browse Mobile Models";
    }

    if (allModelsBtn) {
      allModelsBtn.classList.remove("d-none");
    }

    if (backModelsBtn) {
      backModelsBtn.classList.add("d-none");
    }

    if (backPartsBtn) {
      backPartsBtn.classList.add("d-none");
    }

    getElements(".model-list li, .model-sidebar-item").forEach(function (li) {
      li.classList.remove("active");
    });

    const allModels = getElement(".all-models");

    if (allModels) {
      allModels.classList.add("active");
    }
  }

  /* ======================
       SHOW PARTS
       ====================== */

  function showParts() {
    const modelsGrid = getElement(".models-grid");

    const partsGrid = getElement(".parts-grid");

    const productsGrid = getElement(".products-grid");

    const title = getElement(".main-browser-title");

    const allModelsBtn = getElement(".all-models-btn");

    const backModelsBtn = getElement(".back-models-btn");

    const backPartsBtn = getElement(".back-parts-btn");

    if (modelsGrid) {
      modelsGrid.classList.add("d-none");
    }

    if (partsGrid) {
      partsGrid.classList.remove("d-none");
    }

    if (productsGrid) {
      productsGrid.classList.add("d-none");
    }

    let modelName = selectedModelName;

    if (!modelName && selectedModel) {
      const model = document.querySelector(
        '.load-model[data-model="' + escapeSelector(selectedModel) + '"]',
      );

      if (model) {
        modelName = model.dataset.modelName || model.textContent.trim();
      }
    }

    if (title) {
      title.textContent = modelName
        ? modelName + " Spare Parts"
        : "Spare Parts";
    }

    if (allModelsBtn) {
      allModelsBtn.classList.add("d-none");
    }

    if (backModelsBtn) {
      backModelsBtn.classList.remove("d-none");
    }

    if (backPartsBtn) {
      backPartsBtn.classList.add("d-none");
    }
  }

  /* ======================
       SHOW PRODUCTS
       ====================== */

  function showProducts() {
    const modelsGrid = getElement(".models-grid");

    const partsGrid = getElement(".parts-grid");

    const productsGrid = getElement(".products-grid");

    const title = getElement(".main-browser-title");

    const allModelsBtn = getElement(".all-models-btn");

    const backModelsBtn = getElement(".back-models-btn");

    const backPartsBtn = getElement(".back-parts-btn");

    if (modelsGrid) {
      modelsGrid.classList.add("d-none");
    }

    if (partsGrid) {
      partsGrid.classList.add("d-none");
    }

    if (productsGrid) {
      productsGrid.classList.remove("d-none");
    }

    let categoryName = "";

    const categoryButton = document.querySelector(
      '.select-category[data-category="' +
        escapeSelector(selectedCategory) +
        '"]',
    );

    if (categoryButton) {
      const card = categoryButton.closest(".accessory-card");

      if (card) {
        const heading = card.querySelector("h5");

        if (heading) {
          categoryName = heading.textContent.trim();
        }
      }
    }

    if (!categoryName) {
      categoryName = selectedCategory || "Products";
    }

    if (title) {
      title.textContent = categoryName;
    }

    if (allModelsBtn) {
      allModelsBtn.classList.add("d-none");
    }

    if (backModelsBtn) {
      backModelsBtn.classList.add("d-none");
    }

    if (backPartsBtn) {
      backPartsBtn.classList.remove("d-none");
    }
  }

  /* ======================
       HIDE ALL PARTS
       ====================== */

  function hideAllParts() {
    getElements(".part-item").forEach(function (item) {
      item.style.display = "none";
    });
  }

  /* ======================
       SHOW COMPATIBLE PARTS
       ====================== */

  function showCompatibleParts() {
    getElements(".part-item").forEach(function (item) {
      const models = item.dataset.models
        ? item.dataset.models.trim().split(/\s+/)
        : [];

      const allModels = item.dataset.allModels === "true";

      /*
       * Category compatible with
       * every model.
       */

      if (allModels) {
        item.style.display = "";

        return;
      }

      /*
       * Category compatible with
       * selected model.
       */

      if (selectedModel && models.includes(selectedModel)) {
        item.style.display = "";
      } else {
        item.style.display = "none";
      }
    });
  }

  /* ======================
       RESET PRODUCT COUNTS
       ====================== */

  function resetSparePartCounts() {
    getElements(".spare-product-count").forEach(function (element) {
      element.textContent = "0 Products";
    });
  }

  /* ======================
       CLEAR PRODUCTS
       ====================== */

  function clearProducts() {
    const container = getElement(".products-container");

    const pagination = getElement(".products-pagination");

    const empty = getElement(".products-empty");

    if (container) {
      container.innerHTML = "";
    }

    if (pagination) {
      pagination.innerHTML = "";
    }

    if (empty) {
      empty.classList.add("d-none");
    }
  }

  /* ======================
       LOADING STATE
       ====================== */

  function setProductsLoading(isLoading) {
    const container = getElement(".products-container");

    const loading = getElement(".products-loading");

    if (loading) {
      if (isLoading) {
        loading.classList.remove("d-none");
      } else {
        loading.classList.add("d-none");
      }
    }

    if (container) {
      if (isLoading) {
        container.classList.add("loading");
      } else {
        container.classList.remove("loading");
      }
    }
  }

  /* ======================
       DIRECT SHOPIFY MODEL FILTER
       ====================== */

  function getModelFilterUrl() {
    if (!selectedCollection || !selectedModelId) {
      console.warn("Missing collection or model ID.", {
        selectedCollection,
        selectedModelId,
        selectedModelName,
      });

      return null;
    }

    const modelGid = getModelGid();

    if (!modelGid) {
      return null;
    }

    const url = new URL(
      "/collections/" + encodeURIComponent(selectedCollection),
      window.location.origin,
    );

    url.searchParams.set("filter.p.m.custom.compatible_models", modelGid);

    console.log("DIRECT SHOPIFY MODEL FILTER:", url.toString());

    return url.toString();
  }

  /* ======================
       FIND PRODUCT CARDS
       ======================
  
       IMPORTANT:
  
       ONLY .product-item.
  
       Do NOT use [data-product-handle]
       because the wishlist button also
       has data-product-handle.
       ====================== */

  function findProductCards(doc) {
    const cards = doc.querySelectorAll(".product-item");

    console.log("PRODUCT CARD CHECK:", "Found:", cards.length);

    if (!cards.length) {
      console.error("NO .product-item FOUND IN SHOPIFY RESPONSE");


      return [];
    }

    return Array.from(cards);
  }

  /* ======================
       REMOVE DUPLICATES
       ====================== */

  function removeDuplicateCards(cards) {
    const unique = [];

    const seen = new Set();

    cards.forEach(function (card) {
      let key = "";

      const productId = card.dataset.productId;

      const productHandle = card.dataset.productHandle;

      if (productId) {
        key = "id-" + productId;
      } else if (productHandle) {
        key = "handle-" + productHandle;
      } else {
        key = card.outerHTML;
      }

      if (!seen.has(key)) {
        seen.add(key);

        unique.push(card);
      }
    });

    return unique;
  }

  /* ======================
       INSERT PRODUCTS
       ====================== */

  function insertProducts(cards) {
    const container = getElement(".products-container");

    if (!container) {
      console.error("Products container not found.");

      return 0;
    }

    const uniqueCards = removeDuplicateCards(cards);

    uniqueCards.forEach(function (card) {
      const wrapper = document.createElement("div");

      wrapper.className = "col-xl-3 col-lg-4 col-md-6";

      wrapper.appendChild(card.cloneNode(true));

      container.appendChild(wrapper);
    });

    return uniqueCards.length;
  }

  /* ======================
       CREATE PAGINATION
       ====================== */

  function createPagination(doc) {
    const pagination = getElement(".products-pagination");

    if (!pagination) {
      return;
    }

    pagination.innerHTML = "";

    let links = Array.from(doc.querySelectorAll(".pagination a"));

    if (!links.length) {
      links = Array.from(doc.querySelectorAll("a[href*='page=']"));
    }

    if (!links.length) {
      return;
    }

    const wrapper = document.createElement("div");

    wrapper.className = "spare-pagination-inner";

    links.forEach(function (link) {
      const href = link.getAttribute("href");

      if (!href) {
        return;
      }

      const url = new URL(href, window.location.origin);

      const page = url.searchParams.get("page");

      if (!page) {
        return;
      }

      if (wrapper.querySelector('[data-page="' + page + '"]')) {
        return;
      }

      const button = document.createElement("button");

      button.type = "button";

      button.className = "spare-page-link";

      button.dataset.page = page;

      button.textContent = link.textContent.trim() || page;

      wrapper.appendChild(button);
    });

    if (wrapper.children.length) {
      pagination.appendChild(wrapper);
    }
  }

  /* ======================
       LOAD PRODUCTS
       ====================== */

  async function loadSpareProducts(page = 1) {
    const container = getElement(".products-container");

    const empty = getElement(".products-empty");

    if (!container) {
      console.error("Missing .products-container");

      return;
    }

    if (!selectedCollection || !selectedModelId) {
      console.warn("Cannot load products.", {
        selectedCollection,
        selectedModelId,
        selectedModelName,
      });

      return;
    }

    const requestToken = ++productRequestToken;
    if (productRequestController) productRequestController.abort();
    productRequestController = new AbortController();
    const requestSignal = productRequestController.signal;

    setProductsLoading(true);

    if (empty) {
      empty.classList.add("d-none");
    }

    try {
      /* =========================================
               GET DIRECT SHOPIFY FILTER URL
               ========================================= */

      const filterUrl = getModelFilterUrl();

      if (!filterUrl) {
        throw new Error("Unable to create Shopify model filter URL.");
      }

      console.log("SHOPIFY FILTER URL:", filterUrl);

      /* =========================================
               FINAL URL
               ========================================= */

      const finalUrl = new URL(filterUrl, window.location.origin);

      /*
       * Request our custom section.
       */

      finalUrl.searchParams.set("section_id", "spare-part-products");

      /*
       * Pagination.
       */

      finalUrl.searchParams.set("page", page);

      console.log("FINAL PRODUCT REQUEST:", finalUrl.toString());

      /* =========================================
               FETCH
               ========================================= */


const response = await fetch(finalUrl.toString(), {
  method: "GET",
  cache: "no-store",
  headers: {
    "X-Requested-With": "XMLHttpRequest",
    Accept: "text/html"
  }
});

      if (!response.ok) {
        throw new Error("HTTP " + response.status);
      }

      const html = await response.text();
      if (requestToken !== productRequestToken) return;

      /* =========================================
               PARSE HTML
               ========================================= */

      const parser = new DOMParser();

      const doc = parser.parseFromString(html, "text/html");

      /* =========================================
               FIND PRODUCT CARDS
               ========================================= */

      let cards = findProductCards(doc);
      cards = removeDuplicateCards(cards);
      if (requestToken !== productRequestToken) return;

      /* =========================================
               CLEAR OLD PRODUCTS
               ========================================= */

      container.innerHTML = "";

      /* =========================================
               INSERT
               ========================================= */

      const inserted = insertProducts(cards);


      /* =========================================
               EMPTY
               ========================================= */

      if (inserted === 0) {
        if (empty) {
          empty.classList.remove("d-none");
        }

        console.warn("No products found:", {
          model: selectedModel,

          modelId: selectedModelId,

          modelName: selectedModelName,

          collection: selectedCollection,

          category: selectedCategory,
        });
      }

      /* =========================================
               PAGINATION
               ========================================= */

      createPagination(doc);
    } catch (error) {
      if (error.name === "AbortError" || requestToken !== productRequestToken) return;
      console.error("Spare product loading error:", error);

      container.innerHTML = `
        <div class="col-12">
          <div class="alert alert-danger text-center">
            Unable to load products.
            Please try again.
          </div>
        </div>
      `;
    } finally {
      if (requestToken === productRequestToken) setProductsLoading(false);
    }
  }

  /* ======================
       LOAD PRODUCT COUNTS
       ======================
  
       IMPORTANT:
  
       This uses the SAME Shopify model filter
       used by loadSpareProducts().
  
       Example:
  
       Realme C1
       +
       Charging Connector Collection
       =
       Shopify filtered count
       ====================== */

  async function loadSparePartCounts() {
    const requestToken = ++countRequestToken;
    const partItems = Array.from(document.querySelectorAll(".part-item"));

    if (!partItems.length) {
      console.warn("NO SPARE PART ITEMS FOUND.");
      return;
    }

    if (!selectedModelId) {
      console.warn("NO MODEL ID FOR PRODUCT COUNTS.");
      resetSparePartCounts();
      return;
    }

    console.log("======================================");
    console.log("LOADING SPARE PART COUNTS");
    console.log("MODEL:", selectedModelName);
    console.log("MODEL ID:", selectedModelId);
    console.log("TOTAL PART ITEMS:", partItems.length);
    console.log("======================================");

    const modelGid = getModelGid();

    if (!modelGid) {
      console.warn("MODEL GID IS MISSING.");
      return;
    }

    const requests = partItems.map(async function (item) {
      const button = item.querySelector(".select-category");
      const countElement = item.querySelector(".spare-product-count");

      if (!button || !countElement) {
        return;
      }

      /*
       * Only count spare-part categories
       * that are visible/compatible with
       * the selected model.
       */
      if (item.style.display === "none") {
        return;
      }

      let collection = button.dataset.collection || "";

      /*
       * Fallback to category handle
       * when no collection is assigned.
       */
      if (!collection) {
        collection = button.dataset.category || "";
      }

      if (!collection) {
        console.warn("NO COLLECTION OR CATEGORY:", button.dataset.category);

        countElement.textContent = "0 Products";
        return;
      }

      const cacheKey = modelGid + "::" + collection;
      if (countCache.has(cacheKey)) {
        const cachedCount = countCache.get(cacheKey);
        countElement.textContent = cachedCount === null ? "Products" : cachedCount + (cachedCount === 1 ? " Product" : " Products");
        return;
      }

      countElement.textContent = "Loading...";

      try {
        const url = new URL(
          "/collections/" + encodeURIComponent(collection),
          window.location.origin,
        );

        /*
         * Apply the exact same Shopify
         * Search & Discovery filter.
         */
        url.searchParams.set("filter.p.m.custom.compatible_models", modelGid);

        /*
         * Request the same custom section
         * used for the actual products.
         */
        url.searchParams.set("section_id", "spare-part-products");

        console.log("COUNT REQUEST:", url.toString());

        const response = await fetch(url.toString(), {
          method: "GET",
          headers: {
            "X-Requested-With": "XMLHttpRequest",
            Accept: "text/html",
          },
        });

        if (!response.ok) {
          throw new Error("HTTP " + response.status);
        }

        const html = await response.text();
        if (requestToken !== countRequestToken) return;

        const parser = new DOMParser();

        const doc = parser.parseFromString(html, "text/html");

        /*
         * Get Shopify's returned count.
         */
        const shopifyCountElement = doc.querySelector(".spare-products-count");

        let count = 0;

        if (shopifyCountElement) {
          count = parseInt(
            shopifyCountElement.dataset.productsCount || "0",
            10,
          );

          console.log("SHOPIFY COUNT FOUND:", count);
        } else {
          console.warn("COUNT ELEMENT NOT FOUND IN RESPONSE.");
        }

        /*
         * Fallback: count returned product cards.
         */
        // Do not use the current page's product-card count as a total count.
        // A zero count can be real, and page results may be paginated.
        if (!shopifyCountElement) {
          countCache.set(cacheKey, null);
          countElement.textContent = "Products";
          return;
        }
        countCache.set(cacheKey, count);

        /*
         * Update spare part card.
         */
        if (count === 1) {
          countElement.textContent = "1 Product";
        } else {
          countElement.textContent = count + " Products";
        }

      } catch (error) {
        if (requestToken !== countRequestToken) return;
        console.error("PRODUCT COUNT ERROR:", error);
        countElement.textContent = "Count unavailable";
      }
    });

    await Promise.all(requests);

    console.log("SPARE PART COUNTS COMPLETE");
  }

  /* ======================
       MODEL CLICK
       ====================== */

  document.addEventListener("click", function (event) {
    const button = event.target.closest(".load-model");

    if (!button) {
      return;
    }

    event.preventDefault();

    /* =========================================
             GET MODEL DATA
             ========================================= */

    selectedBrand = button.dataset.brand || "";

    selectedBrandId = button.dataset.brandId || "";

    selectedModel = button.dataset.model || "";

    selectedModelId = button.dataset.modelId || "";

    selectedModelName =
      button.dataset.modelName || button.textContent.trim() || "";

    selectedCategory = "";

    selectedCollection = "";
    if (productRequestController) productRequestController.abort();
    productRequestToken++;
    countRequestToken++;

    console.log("MODEL SELECTED:", {
      selectedBrand,
      selectedBrandId,
      selectedModel,
      selectedModelId,
      selectedModelName,
    });

    /* =========================================
             ACTIVE SIDEBAR
             ========================================= */

    getElements(".model-list li, .model-sidebar-item").forEach(function (li) {
      li.classList.remove("active");
    });

    const sidebarLink = document.querySelector(
      '.model-list .load-model[data-model="' +
        escapeSelector(selectedModel) +
        '"]',
    );

    if (sidebarLink) {
      const li = sidebarLink.closest("li");

      if (li) {
        li.classList.add("active");
      }
    }

    /* =========================================
             SHOW PARTS
             ========================================= */

    // showParts();

    /* =========================================
             SHOW COMPATIBLE PARTS
             ========================================= */

    showCompatibleParts();

    /* =========================================
             RESET COUNTS
             ========================================= */

    resetSparePartCounts();

    /* =========================================
             CLEAR PRODUCTS
             ========================================= */

    clearProducts();

    /* =========================================
             LOAD COUNTS
             ========================================= */

    showParts();
    loadSparePartCounts();
  });

  /* ======================
       CATEGORY CLICK
       ====================== */

  document.addEventListener("click", function (event) {
    const button = event.target.closest(".select-category");

    if (!button) {
      return;
    }

    event.preventDefault();

    /* =========================================
             GET CATEGORY
             ========================================= */

    selectedCategory = button.dataset.category || "";

    selectedCollection = button.dataset.collection || "";

    /*
     * Fallback.
     */

    if (!selectedCollection) {
      selectedCollection = selectedCategory;
    }

    console.log("CATEGORY SELECTED:", {
      selectedCategory,
      selectedCollection,
      selectedModel,
      selectedModelId,
      selectedModelName,
    });

    /* =========================================
             REQUIRE MODEL
             ========================================= */

    if (!selectedModel || !selectedModelId) {
      console.warn("Select a model first.");

      return;
    }

    /* =========================================
             SHOW PRODUCTS
             ========================================= */

    showProducts();

    loadSparePartCounts();

    /* =========================================
             LOAD PRODUCTS
             ========================================= */

    loadSpareProducts(1);
  });

  /* ======================
       ALL MODELS
       ====================== */

  /* ======================
     ALL MODELS
     ====================== */

  document.addEventListener("click", function (event) {
    /*
     * Catch BOTH:
     *
     * 1. Top All Models button
     * 2. Sidebar All Models item
     */

    const button = event.target.closest(".all-models-btn, .all-models");

    if (!button) {
      return;
    }

    /*
     * Stop <a href="#"> from
     * scrolling the page to top.
     */

    event.preventDefault();

    /*
     * Reset selected model.
     */

    selectedModel = "";

    selectedModelId = "";

    selectedModelName = "";

    /*
     * Reset selected category.
     */

    selectedCategory = "";

    selectedCollection = "";

    /*
     * Show model grid.
     */

    showModels();

    /*
     * Hide all spare parts.
     */

    hideAllParts();

    /*
     * Reset product counts.
     */

    resetSparePartCounts();

    /*
     * Clear products.
     */

    clearProducts();

    /*
     * Remove active class
     * from all sidebar items.
     */

    getElements(".model-list li, .model-sidebar-item").forEach(function (li) {
      li.classList.remove("active");
    });

    /*
     * Make All Models active.
     */

    const allModels = getElement(".all-models");

    if (allModels) {
      allModels.classList.add("active");
    }

    /*
     * Make sure the top button
     * is also active if present.
     */

    if (button.classList.contains("all-models-btn")) {
      button.classList.add("active");
    }
  });

  /* ======================
       BACK TO MODELS
       ====================== */

  document.addEventListener("click", function (event) {
    const button = event.target.closest(".back-models-btn");

    if (!button) {
      return;
    }

    event.preventDefault();

    selectedModel = "";

    selectedModelId = "";

    selectedModelName = "";

    selectedCategory = "";

    selectedCollection = "";

    showModels();

    hideAllParts();

    resetSparePartCounts();

    clearProducts();
  });

  /* ======================
       BACK TO PARTS
       ====================== */

  document.addEventListener("click", function (event) {
    const button = event.target.closest(".back-parts-btn");

    if (!button) {
      return;
    }

    event.preventDefault();

    selectedCategory = "";

    selectedCollection = "";

    clearProducts();

    showParts();

    showCompatibleParts();

    /*
     * Counts stay visible because
     * the model is still selected.
     */
  });

  /* ======================
       PAGINATION CLICK
       ====================== */

  document.addEventListener("click", function (event) {
    const button = event.target.closest(".spare-page-link");

    if (!button) {
      return;
    }

    event.preventDefault();

    const page = parseInt(button.dataset.page, 10);

    if (!page || page < 1) {
      return;
    }

    loadSpareProducts(page);
  });

  /* ======================
       INITIAL STATE
       ====================== */

  document.addEventListener("DOMContentLoaded", function () {
    hideAllParts();

    clearProducts();

    resetSparePartCounts();
  });

  /* ======================
       GLOBAL DEBUG ACCESS
       ====================== */

  window.SparePartsBrowser = {
    getState: function () {
      return {
        selectedBrand,

        selectedBrandId,

        selectedModel,

        selectedModelId,

        selectedModelName,

        selectedCategory,

        selectedCollection,
      };
    },

    loadProducts: loadSpareProducts,

    loadSparePartCounts: loadSparePartCounts,

    getModelFilterUrl: getModelFilterUrl,
  };
})();